<template>
	<div>
		<!-- <portal to="tabs_nav">
			<v-tabs centered grow background-color="primary" dark v-model="Ntab">
				<v-tab @click="changeMaterialTab('DIGITALES')">DIGITALES</v-tab>
				<v-tab @click="changeMaterialTab('FÍSICO')">FÍSICO</v-tab>
			</v-tabs>
		</portal>-->

		<!-- CONTENIDO 
		<v-tabs v-model="Ntab" :height="0" class="mt-5">
			<v-tab-item>
				
			</v-tab-item>
			<v-tab-item>
				<grupo-material :grupo="matFisico"></grupo-material>
			</v-tab-item>
		</v-tabs>-->
		<grupo-material :grupo="matDigital"></grupo-material>

		<!-- LOADING -->
		<v-overlay :value="loading">
			<v-progress-circular indeterminate size="64"></v-progress-circular>
		</v-overlay>
	</div>
</template>

<script>
import store from "../store/index";
import { MATERIAL_API } from "../apiConfig";
import { getDataModule } from "../db_save";
import GrupoMaterial from "../components/GrupoMaterial";

export default {
	components: { GrupoMaterial },
	data: () => ({
		Ntab: 0,
		materiales: [],
		matDigital: {
			"Materias Comunes": [],
			"Ing Civil": [],
			"Ing Industrial": [],
			"Ing Informática": [],
			"Ing Telecomunicaciones": [],

			"Materias Comunes (Pensum viejo)": [],
			"Ing Civil (Pensum viejo)": [],
			"Ing Industrial (Pensum viejo)": [],
			"Ing Informática (Pensum viejo)": [],
			"Ing Telecomunicaciones (Pensum viejo)": [],
		},
		matFisico: {
			"Materias Comunes": [],
			"Ing Civil": [],
			"Ing Industrial": [],
			"Ing Informática": [],
			"Ing Telecomunicaciones": [],
		},
		nothingToShow: false,
		loading: true,
	}),
	created() {
		store.commit("toggleTabs", true);
		this.getMateriales();
	},
	methods: {
		getMateriales() {
			//console.log("Get Materialess ", MATERIAL_API);
			//
			getDataModule("materiales", 1000 * 60 * 10, MATERIAL_API)
				.then((materiales) => {
					//console.log("materiales: ", materiales);
					if (materiales.length > 0) {
						this.materiales = materiales;
						this.clasificarMaterial(materiales);
					} else {
						this.materiales = [];
						this.nothingToShow = true;
					}
				})
				.catch((e) => {
					console.error("Error ", e);
				})
				.finally(() => {
					this.loading = false;
				});
		},
		clasificarMaterial() {
			this.materiales.forEach((material) => {
				//console.log("material: ", material.carrera);
				if (material.tipo == "Físico") {
					this.matFisico[material.carrera].push(material);
				} else {
					this.matDigital[material.carrera].push(material);
				}
			});
		},
		changeMaterialTab(tabName) {
			this.$ua.trackEvent(`MaterialInteraccion`, "ChangeTab", tabName);
		},
	},
};
</script>

<style></style>
